'use client';

import React, { useEffect, useRef, forwardRef } from 'react';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/input-otp';
import { ErrorMessage } from '@tajdid/tajdid-ui';

type OtpInputProps = {
  value: string;
  onChange: (otp: string) => void;
  name: string;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
};

export const OtpInput = forwardRef<HTMLInputElement, OtpInputProps>(
  ({ value, onChange, name, error, disabled }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, []);

    useEffect(() => {
      if (error) {
        inputRef.current?.focus();
      }
    }, [error]);

    return (
      <div>
        <InputOTP
          maxLength={4}
          name={name}
          ref={ref || inputRef}
          containerClassName={`group flex items-center has-[:disabled]:opacity-30`}
          onChange={value => onChange(value)}
          value={value}
          disabled={disabled}
        >
          <InputOTPGroup>
            <InputOTPSlot
              className={`${error && 'border-error text-error'}`}
              index={0}
            />
            <InputOTPSlot
              className={`${error && 'border-error text-error'}`}
              index={1}
            />
            <InputOTPSlot
              className={`${error && 'border-error text-error'}`}
              index={2}
            />
            <InputOTPSlot
              className={`${error && 'border-error text-error'}`}
              index={3}
            />
          </InputOTPGroup>
        </InputOTP>
        <ErrorMessage message={error} />
      </div>
    );
  },
);

OtpInput.displayName = 'OtpInput';
